function btyOnVariantChange({target: element}) {
	const mainElement    = this.querySelector( 'main' );
	const productElement = this.querySelector( '.main-product' );
	const recentElement  = this.querySelector( '.product-recently-viewed' );
	const sectionId      = this.dataset.sectionId;
	const oldProductUrl  = productElement.dataset.productUrl;
	let newProductUrl;
	let newVariantId;

	let allProductUrl        = [];
	let firstProductVariants = productElement.querySelector( '.product-variants:first-child' );
	let firstSelectedProductUrl;

	// Check variant is radio button.
	if ( element.type === 'radio' ) {
		newProductUrl = element.dataset.productUrl;
		newVariantId  = element.dataset.variantId;

		allProductUrl = Array.from( this.querySelectorAll( '.variant-field input' ) ).map( ( input ) => input.dataset.productUrl ).filter((url) => url && url.trim() !== '').filter((url, index, self) => self.indexOf(url) === index);
		firstSelectedProductUrl = firstProductVariants.querySelector( '.variant-field:first-child input:checked' ).dataset.productUrl;
	}

	// Check variant is select element.
	if ( element.tagName.toLowerCase() === 'select' ) {
		const selectedOption = element.selectedOptions[0];
		newProductUrl        = selectedOption.dataset.productUrl;
		newVariantId         = selectedOption.dataset.variantId;

		allProductUrl = Array.from( this.querySelectorAll( '.variant-field select option' ) ).map( ( input ) => input.dataset.productUrl ).filter((url) => url && url.trim() !== '').filter((url, index, self) => self.indexOf(url) === index);
		firstSelectedProductUrl = firstProductVariants.querySelector( '.variant-field:first-child select option:checked' ).dataset.productUrl;
	}

	let params = ``;
	if ( newVariantId ) {
		params += `variant=${newVariantId}`;
	}

	// Call the section rendering api.
	fetch( `${newProductUrl}?${params}` )
		.then(
			function ( r ) {
				if ( 200 !== r.status ) {
					console.log( 'Status Code: ' + r.status );
					throw r;
				}

				return r.text();
			}
		).then(
			function (responseText) {
				if (newProductUrl && oldProductUrl !== newProductUrl) {
					// If the product changed, replace the old product with the new product.
					mainElement.innerHTML = btyGetSectionHtml( responseText, 'main' );

					if ( newVariantId ) {
						window.history.replaceState( {}, '', newProductUrl + '?variant=' + newVariantId );
					} else {
						window.history.replaceState( {}, '', newProductUrl );
					}

					// Update anything else that depends on product, such as URL and recommended products.
					return;
				} else {
					if ( allProductUrl.length > 0 && ! allProductUrl.includes( oldProductUrl ) ) {
						fetch( `${firstSelectedProductUrl}?${params}` )
							.then(
								function ( r ) {
									if ( 200 !== r.status ) {
										console.log( 'Status Code: ' + r.status );
										throw r;
									}

									return r.text();
								}
							).then(
								function (res) {
									mainElement.innerHTML = btyGetSectionHtml( res, 'main' );

									if ( newVariantId ) {
										window.history.replaceState( {}, '', firstSelectedProductUrl + '?variant=' + newVariantId );
									} else {
										window.history.replaceState( {}, '', firstSelectedProductUrl );
									}

									// Update anything else that depends on product, such as URL and recommended products.
									return;
								}
							).finally(
								function () {
									btyAnimationImageLoad();
									btyPhotoswipeHandle();
									btyProductVariants();
									btyProductPerformed();
									btyQuantityButton();
									btyAddToCart();
									btyProductPopup();
									btyProductGallery();

									if ( recentElement ) {
										btyRecentlyProduct();
									}
								}
							);
					}
				}
			}
		).finally(
			function () {
				btyAnimationImageLoad();
				btyPhotoswipeHandle();
				btyProductVariants();
				btyProductPerformed();
				btyQuantityButton();
				btyAddToCart();
				btyProductPopup();
				btyProductGallery();

				if ( recentElement ) {
					btyRecentlyProduct();
				}
			}
		);
}

function btyCombinedProduct( doc = document ) {
	let selector = doc.querySelectorAll( '.template-product' );

	if ( ! selector.length ) {
		return;
	}

	selector.forEach(
		function ( el ) {
			el.addEventListener( 'change', btyOnVariantChange );
		}
	);
}

document.addEventListener(
	'DOMContentLoaded',
	function () {
		if ( window.ProductModel ) {
			window.ProductModel.loadShopifyXR();
		}

		btyCombinedProduct();
	}
);

document.addEventListener(
	'shopify:section:load',
	function ( e ) {
		let section = e.target.closest( 'section.shopify-section' );

		btyCombinedProduct( section );
	}
);

document.addEventListener(
	'shopify:section:select',
	function ( e ) {
		let section = e.target;

		btyCombinedProduct( section );
	}
);

document.addEventListener(
	'shopify:block:select',
	function ( e ) {
		let section = e.target.closest( '.shopify-section' );
		if ( ! section ) {
			return;
		}

		btyCombinedProduct( section );
	}
);